import { Modal } from 'antd';
import { ChangeEvent, FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch } from '../../../hooks';
import { User } from '../../../interfaces';
import { useRegisterMutation } from '../../../services';
import { toast } from 'react-toastify';
import { setCredentials } from '../../../slices';
import { handleServerError } from '../../../helpers';


interface IProps {
  isModalVisible: boolean;
  handleCancel: () => void;
}

const Register: FC<IProps> = (props) => {
  const { isModalVisible, handleCancel } = props;
  const dispatch = useAppDispatch();

  const [registerDto, setRegisterDto] = useState<Partial<User>>({
    email: '',
    password: '',
    phone: '',
    name: '',
  });
  const [rePassword, setRePassword] = useState<string>('');

  const [register, { isLoading }] = useRegisterMutation();

  const handleOk = () => {
    if (registerDto.password !== rePassword) {
      return toast.error('Passwords do not match');
    }

    if (!registerDto.email || !registerDto.name || !registerDto.password) {
      return toast.error('Please fill out all required fields');
    }

    if (registerDto.phone === '') {
      delete registerDto.phone;
    }

    register(registerDto)
      .unwrap()
      .then(({ user, accessToken }) => {
        dispatch(setCredentials({ user, accessToken }));
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('accessToken', JSON.stringify(accessToken));
        handleCancel();
      })
      .catch(handleServerError);
  }

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setRegisterDto(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  return (
    <Modal visible={isModalVisible} okButtonProps={{ disabled: isLoading }}
           okText={isLoading ? 'Creating your account...' : 'Create an Account'}
           onOk={handleOk} onCancel={handleCancel}>
      <header><h1>Create Account</h1></header>
      <form>
        <div className="form-group">
          <label htmlFor="name">
            Full name: <span className={"text-danger"}>*</span>
          </label>
          <input type="email" className="form-control" name={"name"}
                 value={registerDto.name} onChange={onChange}
                 id="name" required/>
        </div>
        <div className={"row"}>
          <div className={"col-md-6"}>
            <div className="form-group">
              <label htmlFor="email">
                Email: <span className={"text-danger"}>*</span>
              </label>
              <input type="email" className="form-control" name={"email"}
                     value={registerDto.email} onChange={onChange}
                     id="email" required/>
            </div>
          </div>
          <div className={"col-md-6"}>
            <div className="form-group">
              <label htmlFor="phone">
                Phone: <span>(optional)</span>
              </label>
              <input type="text" className="form-control" name={"phone"}
                     value={registerDto.phone} onChange={onChange}
                     id="phone"/>
            </div>
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-md-6"}>
            <div className="form-group">
              <label htmlFor="password">
                Password: <span className={"text-danger"}>*</span>
              </label>
              <input type="password" className="form-control" name={'password'}
                     value={registerDto.password} onChange={onChange}
                     id="password" required/>
            </div>
          </div>
          <div className={"col-md-6"}>
            <div className="form-group">
              <label htmlFor="rePassword">
                Re-type Password: <span className={"text-danger"}>*</span>
              </label>
              <input type="password" className="form-control" name={"rePassword"}
                     id="rePassword" value={rePassword}
                     onChange={(e) => {
                       setRePassword(e.target.value);
                     }} required/>
            </div>
          </div>
        </div>
      </form>
      <hr/>
      <div className="center">
        <span className={"text-danger"}>*</span>
        By clicking the “Create an Account” button you agree with our&nbsp;
        <Link to="/terms" onClick={handleCancel}>Terms and conditions</Link>
      </div>
    </Modal>
  );
}

export default Register;